"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = watchPhoneWorker;
const effects_1 = require("redux-saga/effects");
const setDelayedCookie_1 = __importDefault(require("./setDelayedCookie"));
function* watchPhoneWorker(action) {
    if (action.payload.isValid && action.payload.value) {
        yield (0, effects_1.call)(setDelayedCookie_1.default, {
            phone: {
                country: action.payload.country,
                formattedValue: action.payload.formattedValue,
                isValid: action.payload.isValid,
                value: action.payload.value
            }
        });
    }
}
//# sourceMappingURL=watchPhoneWorker.js.map